import { useContext } from "react";

import { SelectedTicketsContext } from "../../../contexts/tickets/selectedTickets.context";

const SHIPMENT = {
  _id: "",
  number: "",
  number_string: "",
  type: "",
  tracking_number: "",
  encoded_label: "",
  contact_id: "",
  customer_id: "",
  from: {
    name: "",
    company_displayable_name: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
  },
  to: {
    name: "",
    company_displayable_name: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
  },
  tickets: [
    {
      id: "",
      number: "",
      customer_id: "",
      customer_business_then_name: "",
      contact_id: "",
      _id: "",
    },
  ],
  created_at: "",
  updated_at: "",
};

const CHANGE_HANDLERS = {
  handleChange: () => {},
  handleSearch: () => {},
};

const GetShipmentFormProps = ({
  formObject = SHIPMENT,
  changeHandlers = CHANGE_HANDLERS,
}) => {
  const { selectedTickets, setSelectedTickets } = useContext(
    SelectedTicketsContext
  );
  const {
    _id,
    number,
    number_string,
    type,
    tracking_number,
    encoded_label,
    from,
    to,
    tickets,
    created_at,
    updated_at,
  } = formObject;

  const { handleChange, handleSearch, handleMultiSelectChange } =
    changeHandlers;

  return {
    number: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Number",
        value: number,
        name: "number",
        className: "w-96",
        readOnly: true,
      },
    },
    type: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Type",
        value: type,
        name: "type",
        className: "w-96",
        readOnly: true,
      },
    },
    tracking_number: {
      type: "print",
      props: {
        "data-id": _id,
        label: encoded_label,
        text: tracking_number,
        name: "tracking_number",
        className: "w-96",
      },
    },
    tickets: {
      type: "multiSelect",
      props: {
        label: "Tickets",
        name: "tickets",
        value: tickets,
        childValue: "number",
        link: {
          href: `https://techcyclesolutions.repairshopr.com/tickets`,
          identifier: "id",
          target: "_blank",
          active: true,
        },
        searchValue: "number",
        parentId: _id,
        multiple: true,
        options: selectedTickets.map((ticket) => ({
          id: ticket.id,
          label: ticket.number,
          ticket: ticket.number,
          description: ticket.number,
          ticket_id: ticket.id,
        })),
        search: false,
        onChange: handleMultiSelectChange,
        handleCopyClick: () => {},
      },
    },
    customer: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Customer",
        value:
        type === "outbound"
          ? to.company_displayable_name || to.name
          : from.company_displayable_name || from.name,
        name: "customer",
        readOnly: true,
        handleSearch: handleSearch,
        search: true,
        className: "w-96",
      },
    },
    contact: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Contact",
        value: type === "outbound" ? to.attention_name
        : from.name,
        name: "contact",
        readOnly: true,
        handleSearch: handleSearch,
        search: true,
        className: "w-96",
      },
    },
    created_at: {
      type: "datetime",
      props: {
        "data-id": _id,
        label: "Created At",
        value: created_at,
        name: "created_at",
        readOnly: true,
        className: "w-96",
      },
    },
    updated_at: {
      type: "datetime",
      props: {
        "data-id": _id,
        label: "Updated At",
        value: updated_at,
        name: "updated_at",
        readOnly: true,
        className: "w-96",
      },
    },
  };
};

export default GetShipmentFormProps;
